<template>
  <div class="col-md-6 offset-md-3">
    <div class="login-form mt-4 p-4">
      <div class="row g-3">
        <h4>Восстановить аккаунт</h4>
        <div class="col-12">
          <label>Почта</label>
          <input type="email" name="email" class="form-control" placeholder="Email" v-model="email">
        </div>
        <div class="col-12 error-placeholder">
          <error-label/>
        </div>
        <div class="col-12">
          <button type="submit" class="btn btn-dark float-end" @click="handleClickActionRestore" :disabled="disabledSubmit">Восстановить</button>
        </div>
      </div>
      <hr class="mt-4">
      <div class="col-12 mode-switcher-placeholder">
        <p class="text-center mb-0">Есть аккаунт? <a href="#" @click="handleClickModeLogin" data-mode="login">Войти</a></p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import ErrorLabel from "@/components/ui/ErrorLabel.vue";
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageError } from "@/plugins/ws";
import { useToast } from "@/composables/useToast";
import {RootState} from "@/store";

defineOptions({
  name: 'ComponentsAuthRestore',
});

const emit = defineEmits<{
  switchMode: [mode: string];
}>();

const store = useStore<RootState>();

// Типы для WebSocket сообщений компонента Restore
type RestoreSuccessMessage = WebSocketMessageWithFields<'auth-restore', { email: string }>;
type RestoreFailMessage = WebSocketMessageError<'auth-restore-fail'>;

// Объединенный тип для всех сообщений
type RestoreWebSocketMessageType = RestoreSuccessMessage | RestoreFailMessage;

const internalInstance = getCurrentInstance();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const wsSend = internalInstance?.appContext.config.globalProperties.$wsSend as (signal: string, payload: any) => void;

const email = ref('');
const latestMessageValue = ref(latestMessage);
const disabledSubmit = ref(false);

const setErrorReason = (reason: string) => store.dispatch('errorLabel/setErrorReason', reason);
const unsetErrorReason = () => store.dispatch('errorLabel/unsetErrorReason');

const { showToast } = useToast();

watch(email, () => {
  unsetErrorReason();
});

// WebSocket message handler
const handleWebSocketMessage = (data: RestoreWebSocketMessageType): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'auth-restore':
      signalRestore(data.email);
      break;
    case 'auth-restore-fail':
      signalRestoreFail(data.reason);
      break;
  }
};

watch(latestMessageValue, handleWebSocketMessage);

const handleClickActionRestore = () => {
  wsSend('authRestore', {
    email: email.value,
  });
  disabledSubmit.value = true;
};

const handleClickModeLogin = () => {
  emit('switchMode', 'login');
};

const signalRestore = (email: string) => {
  unsetErrorReason();
  disabledSubmit.value = false;
  store.dispatch('auth/restore', email);
  showToast('Письмо отправлено', 'Проверьте почту для восстановления', 5000);
  emit('switchMode', 'restoreCode');
};

const signalRestoreFail = (payload: string) => {
  setErrorReason(payload);
  disabledSubmit.value = false;
  showToast('Ошибка восстановления', payload, 15000);
};
</script>

<style scoped>

</style>